// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/styles.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NoContent-module_no_content_box_tZsNE {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 60px;
}
`, "",{"version":3,"sources":["webpack://./src/client/components/Generic/Misc/NoContent.module.css"],"names":[],"mappings":"AAAA;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd","sourcesContent":[".no_content_box {\n  composes: no_content from 'Styles/styles.module.css';\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 60px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"no_content_box": `NoContent-module_no_content_box_tZsNE ${___CSS_LOADER_ICSS_IMPORT_0___.locals["no_content"]}`
};
export default ___CSS_LOADER_EXPORT___;
